import { render, staticRenderFns } from "./leave.vue?vue&type=template&id=4103574a&scoped=true"
import script from "./leave.vue?vue&type=script&lang=js"
export * from "./leave.vue?vue&type=script&lang=js"
import style0 from "./leave.vue?vue&type=style&index=0&id=4103574a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4103574a",
  null
  
)

export default component.exports